// Modal.js
import { faDownload, faPause, faPlay, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from "@mui/material";
import { ThunkDispatch } from '@reduxjs/toolkit';
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CALL, DOWNLOADTRANSCRIPT, FULFILLED } from 'src/common/constants';
import { composeThunkAction } from 'src/common/utils';
import { downloadTranscript } from 'src/store/slices/callSlice';
import { RootState } from 'src/store/store';
import { useAudioContext } from '../AudioContext';

const ModalComponent = ({ isOpen, onClose, children, modalHeading, callAttachment, modalType }: any) => {
  const dispatch: ThunkDispatch<object, object, any> = useDispatch();
  const { callId } = useSelector((state: RootState) => state.calls)
  const { triggerPlayId, setTriggerPlayId, playingAudioId } = useAudioContext();
  const handlePlayPause = () => {
    if (callAttachment && callAttachment[0]?.botRecLnk) {
      setTriggerPlayId("botRecLnk");
    }
  };
  const handleDownloadTranscript = async () => {
    try {
      const response = await dispatch(downloadTranscript(callId));
      if (response?.type === `${composeThunkAction(CALL, DOWNLOADTRANSCRIPT)}/${FULFILLED}`) {
        if (response.payload && response.payload.data) {
          const url = response.payload.data.url;
          if (url) {
            const { botTranscriptLnk } = url;
            if (botTranscriptLnk) {
              const link = document.createElement('a');
              link.href = botTranscriptLnk;
              link.download = `${callId}-transcript.txt`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              console.log('No bot transcript link found');
              toast.error('Transcript link is missing');
            }
          } else {
            console.log('No URL found in response payload');
            toast.error('Failed to retrieve transcript URL');
          }
        } else {
          console.log('No data found in response payload');
          toast.error('No data found for the transcript');
        }
      } else {
        console.log('Download transcript action not fulfilled');
        toast.error('Failed to download transcript');
      }
    } catch (error) {
      console.error('Error during download:', error);
      toast.error('An error occurred while downloading the transcript');
    }
  };

  return (
    <>
      <Modal className='call-details-modal' show={isOpen} size="lg" centered scrollable>
        <Modal.Header>
          <div className='d-flex align-items-center gap-3'>
            <h5 className="modal-title fw-semibold">
              {modalHeading}
            </h5>
            {
              (modalType === 'CALL' || modalType === 'CHAT')&& (
                <Tooltip placement="top" title="Transcript">
                  <div>
                    <button
                      type="button"
                      className="btn p-0"
                      onClick={handleDownloadTranscript}
                    >
                      <FontAwesomeIcon icon={faDownload} className="fs-4 text-white" />
                    </button>
                  </div>
                </Tooltip>
              )
            }{
              modalType === 'CALL' && (<Tooltip title={playingAudioId === 'botRecLnk' ? "Pause Bot Audio" : "Play Bot Audio"} placement="top">
                <div>
                  <button
                    type="button"
                    className="btn p-0"
                    onClick={handlePlayPause}
                  >
                    <FontAwesomeIcon icon={playingAudioId === 'botRecLnk' ? faPause : faPlay} className="fs-4 text-white" />
                  </button>
                </div>
              </Tooltip>)
            }
          </div>
          <button
            type="button"
            aria-label="Close"
            className='btn focus-none p-0'
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faTimes} className='fs-4 text-white' />
          </button>
        </Modal.Header>
        <Modal.Body>
          {children}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalComponent;
